// import { apiUrl } from "./getApiUrl";

const getMercureUrl = () => {
  return (
    process.env.REACT_APP_MERCURE_URL ??
    "https://mercure-prod.monkey-tie.com:1338/.well-known/mercure"
  );
  // return apiUrl + "/.well-known/mercure";
};

const mercureUrl = getMercureUrl();

export default mercureUrl;
